import { wrapper, createApiClient, Result, ApiError } from "../base";
import AiAssistQuestionDO = App.Data.AiAssist.AiAssistQuestionDO;

const basePath = `ai-assist`;
const baseClient = createApiClient();

export default class {

	public async processQuestion(
		aiAssistQuestion: AiAssistQuestionDO,
		onToken: (token: any) => void,
		onUuid: (token: any) => void,
		onLoadingState?: (state: string) => void,
		onDocument?: (doc: any) => void,
		onComplete?: (fullAnswer: string) => void,
		onError?: (error: string) => void,
	): Promise<void> {
	try {
		const response = await baseClient.post(`${basePath}/process-question`, aiAssistQuestion, {
			responseType: "stream",
			timeout: 45000
		});

		if (!response.data) throw new Error("No response body");

		const reader = response.data.getReader();
		const decoder = new TextDecoder();
		let buffer = "";
		let fullAnswer = ""

		while (true) {
			const { done, value } = await reader.read();
			if (done) break;

			buffer += decoder.decode(value, { stream: true });
			if (!buffer) continue;

			let boundary;
			while ((boundary = buffer.indexOf("[END]")) !== -1) {
				const jsonStr = buffer.slice(0, boundary).trim();
				buffer = buffer.slice(boundary + 5);

				if (!jsonStr) continue;

				try {
					const { type, value } = JSON.parse(jsonStr);

					switch (type) {
						case "token":
							onToken(value);
							fullAnswer += value;
							break;
						case "uuid":
							onUuid(value);
							break;
						case "loading_state":
							onLoadingState(value);
							break;
						case "document":
							onDocument?.(value);
							break;
						case "error":
							onError?.(value);
							return;
						default:
							console.warn("Unknown stream type:", type);
					}
				} catch (err) {
					console.error("Failed to parse JSON chunk:", jsonStr, err);
				}
				}
				buffer = "";
			}
		onComplete(fullAnswer);

	} catch (error: any) {
		console.error("Stream error: ", error);
		if (error.code === "ETIMEDOUT") {
			onError?.("The request timed out. Please try again later.");
		} else if (error.name === "AbortError") {
			onError?.("The request was cancelled.");
		} else {
			onError?.("An unknown error occurred, Please try again later.");
		}
	}
	}

	markResponseAsHelpful(
		response_uuid: string
	): Promise<Result<AiAssistQuestionDO, ApiError>> {
		return wrapper(
			baseClient.patch(`${basePath}/mark-response-as-helpful/${response_uuid}`)
		);
	}
	markResponseAsNotHelpful(
		response_uuid: string
	): Promise<Result<AiAssistQuestionDO, ApiError>> {
		return wrapper(
			baseClient.patch(
				`${basePath}/mark-response-as-not-helpful/${response_uuid}`
			)
		);
	}
	storeWrittenFeedback(
		aiAssistQuestionDO: AiAssistQuestionDO
	): Promise<Result<AiAssistQuestionDO, ApiError>> {
		return wrapper(
			baseClient.patch(
				`${basePath}/store-written-feedback/${aiAssistQuestionDO.uuid}`,
				aiAssistQuestionDO
			)
		);
	}
}
